import React from "react";

interface Props {
  uploadNewImage: boolean;
  pictureUrl: string;
  profilePicture: string;
  initials: string;
  uploadingImage: boolean;
  progress: number;
  uploadFile: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeImage: (event: React.MouseEvent<HTMLElement>) => void;
}

const UploadProgress = ({ progress }: { progress: number }) => {
  const displayProgress = Math.round(progress);

  return (
    <div className="set-upload-progress">
      <div className="set-upload-progress__meta">
        <span>Uploading photo</span>
        <strong>{displayProgress}%</strong>
      </div>
      <div
        className="set-upload-progress__track"
        role="progressbar"
        aria-label="Profile photo upload progress"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={displayProgress}
      >
        <div
          className="set-upload-progress__bar"
          style={{ width: `${displayProgress}%` }}
        />
      </div>
    </div>
  );
};

const ProfileImage = ({
  imageSrc,
  initials,
}: {
  imageSrc: string;
  initials: string;
}) => {
  return imageSrc ? <img src={imageSrc} alt="" /> : <>{initials}</>;
};

const ProfilePictureUploader = ({
  uploadNewImage,
  pictureUrl,
  profilePicture,
  initials,
  uploadingImage,
  progress,
  uploadFile,
  onChangeImage,
}: Props) => {
  const imageSrc =
    pictureUrl || profilePicture || process.env.TRANSLOADIT_IMAGE_PLACEHOLDER;

  if (uploadNewImage) {
    return (
      <div className="set-pic-row">
        <div className="set-pic">
          <input
            id="profile-picture-upload"
            type="file"
            accept="image/*"
            onChange={uploadFile}
            hidden
          />

          <label htmlFor="profile-picture-upload" className="set-pic-img">
            <ProfileImage imageSrc={imageSrc} initials={initials} />
          </label>

          <label
            htmlFor="profile-picture-upload"
            className="set-pic-cam"
            aria-label="Change photo"
          >
            <svg aria-hidden="true">
              <use href="#ln-camera" />
            </svg>
          </label>
        </div>

        <div className="set-pic-details">
          <div className="set-pic-hint">
            Used on certificates and your community profile. JPG or PNG, up to
            2MB.
          </div>

          {uploadingImage && <UploadProgress progress={progress} />}
        </div>
      </div>
    );
  }

  return (
    <div className="set-pic-row">
      <div className="set-pic">
        <span className="set-pic-img">
          <ProfileImage imageSrc={profilePicture} initials={initials} />
        </span>

        <button
          className="set-pic-cam"
          type="button"
          aria-label="Change photo"
          onClick={(e) => onChangeImage(e)}
        >
          <svg aria-hidden="true">
            <use href="#ln-camera" />
          </svg>
        </button>
      </div>

      <div className="set-pic-hint">
        Used on certificates and your community profile. JPG or PNG, up to 2MB.
      </div>
    </div>
  );
};

export default ProfilePictureUploader;
